import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'landingSeo.studentReviews.title',
    defaultMessage:
      'Découvrez les succès de nos élèves en #Matière<enter></enter>à travers leurs témoignages',
  },
});
